<template>
    <div class="info-help">
        <div class="infobody-help">
            <div class="white-header">
                <div class="tenforty-wrap">
                    <router-link :to="$homeLink" class="c-back__box">
                        <span class="c-back__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14px">
                                <path
                                    d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z">
                                </path>
                            </svg>
                        </span>
                        <div>Return to info.my.vermont.gov</div>
                    </router-link>
                    <h1>Welcome to VDH Patient Profile Support</h1>
                    <div class="sub-headings">
                        <p><b>How can we help you?</b></p>
                        <div class="image-row">
                            <Program_Logo class="help-icon" />
                        </div>
                        <img src="../../assets/VDH_logo_green_horiz.png" />
                        <p class="heading-instruction">
                            Please check the common problems and self-directed solutions available below before
                            contacting the program.
                        </p>
                    </div>
                </div>
            </div>
            <div class="tenforty-wrap">
                <p>This page contains guidance to assist you in accessing the Vermont Department of Health (VDH)
                    integrated registries within Patient Profile, including:</p>
                <ul>
                    <li>Blood Lead Screening Registry (HHLPSS)</li>
                    <li>Developmental Screening Registry (UDS)</li>
                    <li>Hearing Screening Registry (CHHS)</li>
                    <li>Immunization Registry (IMR)</li>
                    <li>Vaccine Inventory Management System (VIMS)</li>
                </ul>
                <p>Only authorized users may access these applications. To request access, please contact the program
                    directly at the contact information provided at the bottom of this page.</p>
                <HelpMfaBlock :envLinks="envLinks" appsRequiring="a VDH application"
                    mfaSupportText="For support, please see contact information below.">
                </HelpMfaBlock>
                <HelpGeneral :envLinks="envLinks"></HelpGeneral>
                <h2 class="faq-header">Browser Compatibility</h2>
                <p class="faq-text">If you are having any issues accessing the VDH hearing screening registry, please
                    make sure the browser that you are using is compatible for use with the application.</p>
                <table class="vdh_table">
                    <thead>
                        <tr>
                            <th>Patient Profile Program</th>
                            <th>Browser Compatibility</th>
                        </tr>
                    </thead>
                    <tbody class="section section-step">
                        <tr>
                            <td>
                                Blood Lead Screening Registry (HHLPSS)
                                <hr />Developmental Screening Registry (UDS)
                                <hr />Hearing Screening Registry (CHHS)
                                <hr />Immunization Registry (IMR)
                                <hr />Vaccine Inventory Management System (VIMS)
                            </td>
                            <td class="brower-data">Edge, Firefox, and Chrome</td>
                        </tr>
                    </tbody>
                </table>
                <div class="noteAlt">
                    <i><font-awesome-icon icon="info-circle" /></i>
                    <div class="noteText">
                        <h2 class="faq-header">For Additional Information and Program Assistance</h2>
                        <p>
                            For additional information, or to contact a VDH Patient Profile affiliated program, click on
                            the program name or email contact information links provided below:
                        </p>
                        <p></p>
                        <table class="">
                            <thead>
                                <tr>
                                    <th>Patient Profile Program</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody class="section section-step">
                                <tr id="blood lead HHLPSS">
                                    <td>Blood Lead Screening Registry (HHLPSS)</td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:ahs.vdhhealthyhomes@vermont.gov?subject=Assistance with myVT - Blood Lead Screening">ahs.vdhhealthyhomes@vermont.gov</a>
                                    </td>
                                </tr>
                                <tr id="dev screening reg">
                                    <td>Developmental Screening Registry (UDS)</td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:ahs.vdhudsregistry@vermont.gov?subject=Assistance with myVT - Developmental Screening Registry (UDS)">ahs.vdhudsregistry@vermont.gov</a>
                                    </td>
                                </tr>
                                <tr id="hearing">
                                    <td>Hearing Screening Registry (CHHS)</td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:ahs.vtehdi@vermont.gov?subject=Assistance with myVT - Hearing Screening Registry (CHHS)">ahs.vtehdi@vermont.gov</a>
                                    </td>
                                </tr>
                                <tr id="IMR">
                                    <td>Immunization Registry (IMR)</td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:imr@vermont.gov?subject=Assistance with myVT - Immunization Registry (IMR)">imr@vermont.gov</a>
                                    </td>
                                </tr>
                                <tr id="vims">
                                    <td>Vaccine Inventory Management System (VIMS)</td>
                                    <td class="brower-data">
                                        <a class="email-link"
                                            href="mailto:imr@vermont.gov?subject=Assistance with myVT - VIMS">imr@vermont.gov</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Program_Logo from '../../assets/AHS_VDH_Patient_Profile.vue'
import HelpMfaBlock from './HelpMFABlock.vue'
import HelpGeneral from './HelpGeneral.vue'
export default {
    name: 'help-vdh-patient-profile',
    props: ['envLinks'],
    components: {
        Program_Logo,
        HelpGeneral,
        HelpMfaBlock
    },
    mounted() {
        document.title = "myVT Help - VDH Patient Profile";
    },
}
</script>

<style scoped>
@import './help.css';

.help-icon {
    width: 100px;
}

ul {
    padding-left: 30px;
}

li {
    list-style-type: disc !important;
}

tbody td:nth-child(2) {
    padding-left: 16px;
}

thead th {
    padding-bottom: 10px;
}
</style>
